import { forwardRef } from 'react';

import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent } from './card-with-clock.svg';

export const CardWithClockIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon ref={ref} component={ReactComponent} inheritViewBox {...props} />
  ),
);

if (process.env.NODE_ENV !== 'production') {
  CardWithClockIcon.displayName = 'CardWithClockIcon';
}
